<template>
<div class="form">
  <v-card style="margin-top: 250px">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      <h1 align="center" style="text-decoration: underline overline;">HK4 - AKTIVITI ICT</h1>

      <v-text-field
        outlined 
        dense
        rounded
        v-model="HID"
        label="HID"
        :rules="rules"
        width="20px"
        disabled
      ></v-text-field>



    <!-- DATATABLE  -->
    <v-card  color="rgba(217, 217, 217, 0.5)" class="mb-5">
          <v-card-title>
              Senarai
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>

          <v-spacer></v-spacer>
              <v-btn
              color="error"
              small
              @click="dialogPengesahan=true;"
              >
                Padam
              </v-btn>
          </v-card-title>
          
          <v-data-table
            :headers="headers"
            :items="dataHK4"
            :search="search"
            class="ml-3 mr-3"
            @click:row="handleClick"
          >
            <template v-slot:item.HK4a2= "{ item }">
            {{ formatNumber(item.HK4a2) }}
            </template>
            <template v-slot:item.HK4a3= "{ item }">
            {{ formatNumber(item.HK4a3) }}
            </template>
            <template v-slot:item.HK4a4= "{ item }">
            {{ formatNumber(item.HK4a4) }}
            </template>
            <template v-slot:item.HK4C1= "{ item }">
            {{ formatNumber(item.HK4C1) }}
            </template>
            <template v-slot:item.HK4C3= "{ item }">
            {{ formatNumber(item.HK4C3) }}
            </template>
            <template v-slot:item.HK4C4= "{ item }">
            {{ formatNumber(item.HK4C4) }}
            </template>
            <template v-slot:item.HK4INCS21b= "{ item }">
            {{ formatNumber(item.HK4INCS21b) }}
            </template>
            <template v-slot:item.HK4INCS21b_i= "{ item }">
            {{ formatNumber(item.HK4INCS21b_i) }}
            </template>
            <template v-slot:item.HK4INCS21b_ii= "{ item }">
            {{ formatNumber(item.HK4INCS21b_ii) }}
            </template>
            <template v-slot:item.HK4INCS21b_iii= "{ item }">
            {{ formatNumber(item.HK4INCS21b_iii) }}
            </template>
            <template v-slot:item.HK4INCS21c= "{ item }">
            {{ formatNumber(item.HK4INCS21c) }}
            </template>
          </v-data-table>
    </v-card>   
    </v-card>


<v-card>
  <v-card-title>
    Pendapatan daripada pekerjaan bergaji
  </v-card-title>

  <v-card-text>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >

      <!-- s24 -->
      <v-row v-show="showS24">
        <v-col>
        S24 : Apakah jenis pekerjaan anda atau ahli isi rumah? <strong>[PK]</strong>
        <v-autocomplete
            :items="masco"
            :item-text="item => item.kod +' - '+ item.keterangan"
            return-object
            outlined
            dense
            v-model="HK4PK"
            :rules="rules"
        ></v-autocomplete>
        </v-col>
      </v-row>

      <!-- s25 -->
      <v-row v-show="showS25">
        <v-col>
        S25 : Apakah aktiviti/hasil pengeluaran utama (industri) tempat anda bekerja? <strong>[PN]</strong>
        <v-autocomplete
            :items='msic'
            :item-text="item => item.kod +' - '+ item.keterangan"
            return-object
            outlined
            dense
            v-model="HK4PN"
        ></v-autocomplete>
        </v-col>
      </v-row>

     <!-- s26 -->
      <v-row>
        <v-col>
        S26 : Nyatakan tempoh bagi soalan S24 <strong>[M]</strong>
          <v-row>

            <!-- tempoh -->
            <v-col cols="4">
              <v-autocomplete
                  min="0"
                  maxlength="2"
                  :items="tambahlookupbulan"
                  v-model="HK4M"
                  :value="HK4M"
                  label="Tempoh(bulan)"
                  outlined
                  dense
                  :item-text="item => item.id"
                  item-value="id"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

<v-form ref="form2"  :disabled="disabledInput"> <!-- disable input kalau month NaN/empty -->
      <!-- s38 -->
      <v-row>                                             
          <v-col cols="4">
          S38. Mempunyai akaun penyata kira-kira? 
          <v-select
              :items="yaTidak"
              item-text="desc"
              return-object
              solo
              dense
              v-model="HK4S38"
          ></v-select>          
          </v-col>                                 
      </v-row>

<div v-show="soalanAkaunPenyataYa">
      <!-- s39 -->
      <v-row>
        <v-col>
          S39 : Tempoh penyata kira-kira (dalam bulan)
          <v-row>
              <v-col cols="4" sm="6" md="4">
                <v-text-field
                      v-model="HK4S39"
                      label="bulan"
                      outlined
                      type="number"
                      dense
                ></v-text-field>
              </v-col>

          </v-row>
        </v-col>
      </v-row>

      <!-- s40 -->
      <v-row v-show="showS40">
        <v-col>
          S40. Keuntungan bersih sebagaimana tercatat dalam penyata kira-kira dalam 12 bulan yang lalu <strong>[B1]</strong>                                                        
          <v-row>
            <v-col cols="4" sm="4" md="4">
              Tempoh Bekerja
              <v-text-field
                    v-model="HK4b1"
                    label="RM"
                    outlined
                    type="number"
                    dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- s41 -->
      <v-row v-show="showS41">
        <v-col>
          S41. Anggaran keuntungan bersih berdasarkan penyata kira-kira tahun sebelum ini dalam 12 bulan yang lalu <strong>[B2]</strong><v-row>
            <v-col cols="4" sm="4" md="4">
              Tempoh Bekerja
              <v-text-field
                    v-model="HK4b2"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                  :rules="schemeRule.no8digit" 
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
</div>

<div v-show="soalanAkaunPenyataTidak">
      <!-- s61 -->
      <v-row>
        <v-col>
          S61. Nyatakan jumlah bulan berniaga dalam setahun  <strong>[A1]</strong><v-row>
            <v-col cols="4" sm="4" md="4">
              Tempoh Bekerja
              <v-text-field
                    v-model="HK4a1"
                    label="Bulan"
                    outlined
                    type="number"
                    dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- s62 -->
      <v-row>
        <v-col>
          S62. Nyatakan purata penerimaan daripada jualan bulanan bagi barang dan perkhidmatan ICT <strong>[A2]</strong>
          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                    v-model="HK4a2"
                    label="RM"
                    outlined
                    type="number"
                    dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- s63 -->
      <v-row>
        <v-col>
          S63. Purata perbelanjaan bulanan <br><strong>[A3]</strong>
          Termasuk gaji dan upah, sewa ruang pejabat, elektrik, bahan bakar, air, pembaikan dan penyelenggaraan, cukai tidak langsung misalnya cukai tanah, cukai pintu, dll., nilai barang-barang yang dibeli untuk dijual semula, harga pembelian barang-barang mentah dan perbelanjaan lain
          <v-row>
              <v-col cols="4" sm="4" md="4">
              <v-text-field
                    v-model="HK4a3"
                    label="RM"
                    outlined
                    type="number"
                    dense
              ></v-text-field>
            </v-col>  
          </v-row>     
        </v-col>
      </v-row>
</div>

      <!-- s64 -->
      <v-row>
        <v-col>
          S64. Purata keuntungan bersih bulanan <strong>[A4]</strong>
          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                    v-model="HK4a4"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                  :rules="schemeRule.no8digit" 
              ></v-text-field>
            </v-col>
          </v-row>          
        </v-col>
      </v-row>

      <!-- s65 -->
      <v-row>
        <v-col>
          S65. Pendapatan bersih <strong>[C1]</strong>
          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                    v-model="HK4C1"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                  :rules="schemeRule.no8digit" 
              ></v-text-field>
            </v-col> 
          </v-row>         
        </v-col>
      </v-row>

      <!-- s66 -->
     <v-row>
        <v-col>
          S66. Peratus pembahagian di C1 yang dipegang oleh ahli isi rumah <strong>[C2]</strong>
          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                    v-model="HK4C2"
                    label="Peratus"
                    outlined
                    type="number"
                    dense
                    :min="0"
                    :max="100"
                    :rules="[rules.percentage,rules.takmauPoint]"
              ></v-text-field>
            </v-col> 
          </v-row>         
        </v-col>
      </v-row> 

      <!-- s67 -->
      <v-row>
        <v-col>
          S67. Nilai mutlak bagi C2 <strong>[C3]</strong>
          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                    v-model="HK4C3"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                  :rules="schemeRule.no8digit" 
              ></v-text-field>
            </v-col> 
          </v-row>         
        </v-col>
      </v-row>

      <!-- s68 -->
      <v-row>
        <v-col>
          S68. Anggaran barangan keluaran yang digunakan sendiri setahun dalam 12 bulan yang lalu  <strong>[C4]</strong>
          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                    v-model="HK4C4"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                  :rules="schemeRule.no8digit" 
              ></v-text-field>
            </v-col> 
          </v-row>         
        </v-col>
      </v-row>

      <!-- s69 -->
      <v-row>
        <v-col>
          S69. Pendapatan bersih yang diterima oleh isi rumah <strong>[C5]</strong>
          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field                    
                    v-model="HK4INCS21b"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                  :rules="schemeRule.no8digit" 
              ></v-text-field>
            </v-col>  
          </v-row>        
        </v-col>
      </v-row>

      <!-- s70-->
      <v-row>
        <v-col>
          S70. Pendapatan daripada C5: <br>          
          <v-row class="mt-2">
            <v-col cols="4" sm="4" md="4">
              i. Pendapatan berkaitan ICT dalam talian melalui transaksi e-dagang (cth: menerima pesanan melalui tiktok shop, lazada, shopee, laman web khusus, dll) <strong>[INCS21b(i)]</strong>
              <!-- <v-text-field
                    v-model="HK421bi"
                    outlined
                    type="number"
                    hint="%"
                    persistent-hint
                    dense
                    :rules="[rules.percentage,rules.takmauPoint]"
              ></v-text-field> -->
              <v-text-field
                    v-model="HK4INCS21bi"
                    label=RM
                    outlined
                    type="number"
                    persistent-hint
                    dense
                    @keypress="limitDigits"
                  :rules="schemeRule.no8digit" 
              ></v-text-field>

              
            </v-col>

            <v-col cols="4" sm="4" md="4">
              ii. Pendapatan berkaitan ICT dalam talian melalui transaksi bukan e-dagang (cth: menerima pesanan melalui whatsapp, emel, dll) <strong>[INCS21b(ii)]</strong>
              <!-- <v-text-field
                    v-model="HK421bii"
                    outlined
                    type="number"
                    hint="%"
                    persistent-hint
                    dense
                    :rules="[rules.percentage,rules.takmauPoint]"
              ></v-text-field> -->
              <v-text-field
                    v-model="HK4INCS21bii"
                    label=RM
                    outlined
                    type="number"
                    persistent-hint
                    dense
                    @keypress="limitDigits"
                  :rules="schemeRule.no8digit" 
              ></v-text-field>  
            </v-col>

            <v-col cols="4" sm="4" md="4">
              iii. Pendapatan berkaitan ICT bukan dalam talian  <strong>[INCS21b(iii)]</strong>
              <br>
              <br>
              <br>
              <!-- <v-text-field
                    v-model="HK421biii"
                    outlined
                    type="number"
                    hint="%"
                    persistent-hint
                    dense
                    :rules="[rules.percentage,rules.takmauPoint]"
              ></v-text-field> -->
              <v-text-field
                    v-model="HK4INCS21biii"
                    label=RM
                    outlined
                    type="number"
                    persistent-hint
                    dense
                    @keypress="limitDigits"
                  :rules="schemeRule.no8digit" 
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- s71 -->
      <v-row>
        <v-col>
          S71. Nyatakan komisen daripada aktiviti ICT <strong>[INCS21c]</strong>
          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                    v-model="HK4INCS21c"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                  :rules="schemeRule.no8digit" 
              ></v-text-field>
            </v-col>  
          </v-row>        
        </v-col>
      </v-row>

</v-form>

</v-form>
      <!-- s37 -->
      <v-row>
        <v-col cols="6">
        S37 : Adakah anda atau ahli isi rumah mempunyai pekerjaan lain dalam tempoh 12 bulan yang lalu? <strong>[KL]</strong>
        <v-select
            :items="yaTidak"
            item-text="desc"
            return-object
            solo
            dense
            v-model="HK4KL"
        ></v-select>
        </v-col>
      </v-row>

  </v-card-text>

 
<v-card-actions>
 <v-spacer></v-spacer>
    <v-btn
        text
        color="primary"
        @click='simpan()'
        v-show="butangSimpan"
    >
      Simpan
    </v-btn>
    <v-btn
      text
      color="primary"
      v-show="butangKemaskini"
      @click="updateHK4()"
    >
      Kemaskini
    </v-btn>
     <v-btn
      text
      color="primary"
      v-show="butangKemaskini"
      @click="goTo('2')"
    >
      Seterusnya
    </v-btn>
</v-card-actions>
</v-card>

 <v-alert
  prominent
  type="error"
  :value="popUpALert"
 >
  <v-row align="center" class="mb-2">
    <v-col class="grow">
      Adakah anda pasti untuk padam?
    </v-col>
    <v-col class="shrink">
      <v-btn @click="padam('1')" class="mb-3">Confirm</v-btn>
      <v-btn @click="padam('2')">Cancel</v-btn>
    </v-col>
  </v-row>
</v-alert>
  
 
<!-- Error Dialog -->
<v-dialog
      v-model="errorDialog"
      width="500"
      height="200"
    >
    <v-card>
      <v-alert
        dense
        outlined
        color="#C51162"
        type="error"
      >
      <strong>{{errMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>

<!-- Success Dialog -->
<v-dialog
      v-model="successDialog"
      max-width="800"
      height="200"
    >
    <v-card
      color="success"
    >
      <v-alert
        dense
        outlined
        color="#C51162"
        type="success"
      >
      <strong>{{successMessage}}</strong>
      </v-alert>

      <v-card-actions> 
        <v-spacer></v-spacer>
            <v-btn
                color="warning"
                @click='successDialog = false;'
            >
              Batal
            </v-btn>
            <!-- <v-btn
                color="primary"
                @click='goTo("1")'
            >
              Ke Ringkasan Isi Rumah
            </v-btn> -->
            <v-btn
              color="primary"
              @click='goTo("2")'
            >
              Pengisian Seterusnya
            </v-btn>
      </v-card-actions>
    </v-card>
</v-dialog>

<!-- Kemaskini Dialog -->
<v-dialog
      v-model="kemaskiniDialog"
      max-width="800"
      height="200"
    >
    <v-card
    >
      <v-alert
        dense
        solo
      >
      <strong>Data Dipilih, Sila Mulakan Pengemaskinian</strong>
      </v-alert>
    </v-card>
</v-dialog>

<!-- Pengesahan Padam Dialog -->
 <v-row justify="center">
    <v-dialog
      v-model="dialogPengesahan"
      persistent
      max-width="330"
    >
      <v-card>
        <v-card-text>
         <strong style="color: red"> {{$t("PERHATIAN segala pengisian anda pada borang ini akan dipadam dan pengisian semula harus dilakukan!")}}</strong><br><br>
         {{$t("Adakah anda pasti untuk memadam pengisian?")}}<br><br>
         <!-- <strong>{{$t(" HID: "+this.HID)}}</strong> -->
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            @click="dialogPengesahan = false;"
          >
           {{$t('batal')}}
          </v-btn>
          <v-btn
            color="error"
            @click="padamData()"
          >
            {{$t('padam')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>



</div>
</template>
<script>
import axios from '../../plugins/axios'
import schemeRule from '../../utils/scheme'
//////////////////////////import services///////////////////
import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage(); 

import hidServices from "@/services/lookupField";
const lookup = new hidServices();

import lookupField from '@/services/lookupField'
const lookupFieldServices = new lookupField();
//////////////////////////end import services//////////////

export default {
    // props:['data'],
    async beforeMount(){
        //this.getUnits('ayam')
        var dataHID = localStorageData.getHIDdata()

        this.HID = dataHID.HID;
        this.BNO = dataHID.BNO;
        this.Ps = dataHID.P;
        this.S = dataHID.S;
        this.NG = dataHID.NG;
        this.DP = dataHID.DP;
        this.DB =  dataHID.DB;
        this.BP = dataHID.BP;
        this.ST = dataHID.ST;
        this.NOTK = dataHID.NOTK;
        this.NOAIR = dataHID.NOAIR;
        this.Bulan = dataHID.BULAN;
        this.Tahun = dataHID.TAHUN;

        this.masco = await lookupFieldServices.getMasco(); //dapatkan lookup masco
        this.msic = await lookupFieldServices.getMsic(); //dapatkan lookup msic
        this.yaTidak = lookupFieldServices.getYaTidak();

        this.currNOAIRData = localStorageData.getCurrentNOAIRData();//dapatkan NOAIR yang di click dari page depan
        this.NOAIR = this.currNOAIRData.NOAIR;
        
        this.getData();//dapatkan data based on HID


    },
    data: () => ({
        disabledInput: true,
        updateButton: true,
        saveButton: false,
        butangSimpan: true,
        butangKemaskini: false,

        dialog: false,
        successDialog: false,
        errorDialog: false,
        successMessage:'',
        errMessage:'',
        message: "Saving Data",
        popUpALert:false,
        kemaskiniDialog: false,
        dialogPengesahan: false,

        search: '',
        currNOAIRData:'',
        masco:[],
        msic:[],
        yaTidak:[],
        selectedData: [],

        soalanAkaunPenyataYa:false,
        soalanAkaunPenyataTidak:false,
        showS24 : true,
        showS25 : true,
        showS40 : false,
        showS41 : false,
        dateMula : '',
        dateTamat: '',
        menu1: '',
        menu2:'',
      
        /////////////////////data declaration//////////////////////////
        HID: '',
        KAW: 1,
        Bulan:'',
        Tahun:'',
        BNO:'',
        Ps:'',
        S:'',
        NG: '',
        DP:'',
        DB:'',
        BP:'',
        ST:'',
        NOTK:'',
        NOIR:'',
        R:1,
        
        HK4PK:'',
        HK4PN:'', 
        HK4M:'', 
        HK4S38:0,
        HK4S39:0,
        HK4b1:0,
        HK4b2:0, 
        HK4a1:0, 
        HK4a2:0, 
        HK4a3:0, 
        HK4a4:0, 
        HK4C1:0, 
        HK4C2:0, 
        HK4C3:0, 
        HK4C4:0, 
        HK421bi:0,
        HK421bii:0,
        HK421biii:0,
        HK4INCS21b:0, 
        HK4INCS21bi:0, 
        HK4INCS21bii:0,
        HK4INCS21biii:0,
        HK4INCS21c:0,
        HK4KL:'',        
        dataHK4: [],
        rules: {
          required: v => !!v || 'field is required',
          emel: (value) => {
            return /.+@.+\..+/.test(value) || 'E-mail must be valid'
          },
          percentage:(value)=>{
            return (value <= 100) || 'Percentage must between 1 - 100'
          },
          takmauPoint:(value)=>{
            return (value % 1 === 0)? true:'No point needed'
          }
          
        },
        headers: [
          {
            text: 'NOAIR',
            align: 'start',
            sortable: false,
            value: 'NOAIR',
          },
          { text: 'HID', value: 'HID' },
          { text: 'NOAIR', value: 'NOAIR' },
          { text: 'PK', value: 'HK4PK' },
          { text: 'PN', value: 'HK4PN' },
          { text: 'M', value: 'HK4M' },
          { text: 'S38', value: 'HK4S38' },
          { text: 'S39', value: 'HK4S39' },
          { text: 'B1', value: 'HK4b1' },
          { text: 'B2', value: 'HK4b2' }, 
          { text: 'A1', value: 'HK4a1' }, 
          { text: 'A2', value: 'HK4a2' }, 
          { text: 'A3', value: 'HK4a3' }, 
          { text: 'A4', value: 'HK4a4' }, 
          { text: 'C1', value: 'HK4C1' }, 
          { text: 'C2', value: 'HK4C2' }, 
          { text: 'C3', value: 'HK4C3' }, 
          { text: 'C4', value: 'HK4C4' }, 
          { text: 'C5', value: 'HK4INCS21b' }, 
          { text: 'INCS21b(i)', value: 'HK4INCS21b_i' }, 
          { text: 'INCS21b(ii)', value: 'HK4INCS21b_ii' }, 
          { text: 'INCS21b(iii)', value: 'HK4INCS21b_iii' }, 
          { text: 'INCS21c', value: 'HK4INCS21c' }, 
          { text: 'KL', value: 'HK4KL' },
         

        ],
       ///////////link untuk ke page/////////////////////
      breadcrumbs: [
        {
          text: 'Status Pengisian',
          disabled: false,
          href: 'ringkasanMaklumatIR',
        },
          {
          text: 'HK4',
          disabled: true,
          href: 'hk4',
        },
      ],
      valid: true,
      select: null,
      checkbox: false,
    }),

    methods: {
      formatNumber(value) {
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      stripCommas(value) {
        return value.replace(/,/g, '');
      },
      getUnits: function(a) {
            alert(`${a}`)
      },
      validate () {
        this.$refs.form.validate()
      },
      reset() {
        this.$refs.form.reset();
        this.$refs.form2.reset();
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      limitDigits(event) {
        const value = event.target.value;
        if (value.length >= 8) {
            event.preventDefault();
        }
      },
      async simpan (){
      
        if (this.$refs.form.validate()){
            //this.dialog =  true;
            //setTimeout(() => (this.dialog = false), 2000)
         
            try {

            const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/HK4`, {
              HID: this.HID,
              NOAIR: this.NOAIR,
              KAW: this.KAW,
              Bulan: this.Bulan,
              Tahun: this.Tahun,
              IDBPK: this.IDBPK,
              HK4PK: this.HK4PK.kod,
              HK4PN: this.HK4PN.kod,
              // dateMula: this.dateMula,
              // dateTamat: this.dateTamat, 
              HK4M: this.HK4M, 
              HK4S38: this.HK4S38.id,
              HK4S39: this.HK4S39,
              HK4b1: this.HK4b1,
              HK4b2: this.HK4b2, 
              HK4a1: this.HK4a1, 
              HK4a2: this.HK4a2, 
              HK4a3: this.HK4a3, 
              HK4a4: this.HK4a4, 
              HK4C1: this.HK4C1, 
              HK4C2: this.HK4C2, 
              HK4C3: this.HK4C3, 
              HK4C4: this.HK4C4, 
              // HK421bi: this.HK421bi, 
              // HK421bii: this.HK421bii, 
              // HK421biii: this.HK421biii, 
              HK4INCS21b: this.HK4INCS21b, 
              HK4INCS21bi: this.HK4INCS21bi, 
              HK4INCS21bii: this.HK4INCS21bii,   
              HK4INCS21biii: this.HK4INCS21biii, 
              HK4INCS21c: this.HK4INCS21c, 
              HK4KL: this.HK4KL.id,

                //////////total yang perlu diupdate ke jr5///////////
                totalHK4INCS21b : this.totalHK4INCS21b,
                totalHK4INCS21B_i : this.totalHK4INCS21B_i,
                totalHK4INCS21B_ii : this.totalHK4INCS21B_ii,
                totalHK4INCS21B_iii : this.totalHK4INCS21B_iii,
            
              })

                this.res = res.data;
                this.reset();
                this.getData();
                this.successMessage = 'Data Disimpan!';
                this.successDialog = true;
                window.scrollTo(0, 0);
                
                //setTimeout(() => (this.goTo()), 1000);
                
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
            }
        }else{
          window.scrollTo(0, 0);
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'Please fill in the field!';
        }
      },
      // saveC5(){

      // }
      async updateHK4(){
          
            try {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/updateHK4`, {
                
                HID: this.HID,
                NOAIR: this.NOAIR,
                KAW: this.KAW,
                Bulan: this.Bulan,
                Tahun: this.Tahun,
                IDBPK: this.IDBPK,
                HK4PK: this.HK4PK,
                HK4PN: this.HK4PN,
                // dateMula: this.dateMula,
                // dateTamat: this.dateTamat, 
                HK4M: this.HK4M, 
                HK4S38: this.HK4S38.id,
                HK4S39: this.HK4S39,
                HK4b1: this.HK4b1,
                HK4b2: this.HK4b2, 
                HK4a1: this.HK4a1, 
                HK4a2: this.HK4a2, 
                HK4a3: this.HK4a3, 
                HK4a4: this.HK4a4, 
                HK4C1: this.HK4C1, 
                HK4C2: this.HK4C2, 
                HK4C3: this.HK4C3, 
                HK4C4: this.HK4C4, 
                HK4INCS21b: this.HK4INCS21b, 
                HK4INCS21bi: this.HK4INCS21bi, 
                HK4INCS21bii: this.HK4INCS21bii, 
                HK4INCS21biii: this.HK4INCS21biii, 
                HK4INCS21c: this.HK4INCS21c, 
                HK4KL: this.HK4KL.id,

                //////////total yang perlu diupdate ke jr5///////////
                totalHK4INCS21b : this.totalHK4INCS21b,
                totalHK4INCS21B_i : this.totalHK4INCS21B_i,
                totalHK4INCS21B_ii : this.totalHK4INCS21B_ii,
                totalHK4INCS21B_iii : this.totalHK4INCS21B_iii,

              })
                this.res = res.data;
                this.reset();
                this.getData();
                this.butangKemaskini = false;
                this.successMessage = 'Data Dikemaskini!';
                this.successDialog = true;
                window.scrollTo(0, 0);
                
            } catch (error) {
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Kemaskini : '+error;
            }  
      },
      async padamData(){

        try {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/delete`, {
                HID:  this.HID,
                NOAIR: this.NOAIR,
                table: "HK4"
              })
                this.res = res.data;
                this.reset();
                this.dialogPengesahan = false;
                this.successDialog = true;
                setTimeout(() => (this.successDialog = false), 2000);
                this.successMessage = 'Data Dipadam!'
                this.getData(); 
              
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Padam : '+error;
            }  
      },
      async getData(){
        //dapatkan data dari table HK4 based on HID
   
        try {
            const res = await axios.get(`${process.env.VUE_APP_API_URL}/HK/HK4?HID=`+this.HID+`&NOAIR=`+this.NOAIR, {
            })
            // var dataz = res.data.data
            this.dataHK4 = res.data.data;
          } catch (error) {
            //console.log(error)
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'getData : '+ error;
          }
      },
      handleClick(row) {
          this.selectedData = [];
          this.selectedData = row;

          this.kemaskiniDialog = true;
          setTimeout(() => (this.kemaskiniDialog = false), 1000);


          this.butangSimpan = false;
          this.butangKemaskini = true;
          this.showS24 = false;
          this.showS25 = false;

          this.NOAIR = row.NOAIR;
          this.HK4PK = row.HK4PK;
          this.HK4PN = row.HK4PN;
          this.HK4M = row.HK4M;
          this.HK4S38 = row.HK4S38;          
          this.HK4S39 = row.HK4S39;

          this.HK4a1 = this.stripCommas(row.HK4a1);
          this.HK4a2 = this.stripCommas(row.HK4a2);
          this.HK4a3 = this.stripCommas(row.HK4a3);
          this.HK4a4 = this.stripCommas(row.HK4a4);
          this.HK4b1 = row.HK4b1;
          this.HK4b2 = row.HK4b2;
          this.HK4C1 = this.stripCommas(row.HK4C1);
          this.HK4C2 = this.stripCommas(row.HK4C2);
          this.HK4C3 = this.stripCommas(row.HK4C3);
          this.HK4C4 = this.stripCommas(row.HK4C4);
          this.HK4INCS21b = this.stripCommas(row.HK4INCS21b);
          this.HK4INCS21bi = this.stripCommas(row.HK4INCS21b_i);
          this.HK4INCS21bii = this.stripCommas(row.HK4INCS21b_ii);
          this.HK4INCS21biii = this.stripCommas(row.HK4INCS21b_iii);
          this.HK4INCS21c = this.stripCommas(row.HK4INCS21c);

// kemaskini button 10/11/22
                this.totalHK4INCS21b = row.totalHK4INCS21b;
                this.totalHK4INCS21B_i = row.totalHK4INCS21B_i;
                this.totalHK4INCS21B_ii = row.totalHK4INCS21B_ii;
                this.totalHK4INCS21B_iii =row.totalHK4INCS21B_iii;

          if(row.HK4S38 == 1){
            this.HK4S38 = this.yaTidak[0];
          }
          if(row.HK4S38 == 2){
            this.HK4S38 = this.yaTidak[1];
          }

          //this.HK4KL= row.HK4KL;        
          
            if(row.HK4KL == 1){
              this.HK4KL = this.yaTidak[0];
            }
            if(row.HK4KL == 2){
              this.HK4KL = this.yaTidak[1];
            }
      },
      
      goTo(option){

        if(option == "1"){
          this.$router.push({name: "ringkasanMaklumatIR"});
        }

        if(option == "2"){
      
          if(this.HK4KL.id == "1"){
            this.$router.push({name: "JRB"});
          }
          if(this.HK4KL.id == "2"){
            this.$router.push({name: "ringkasanMaklumatIR"});
          }
         
        }   
      }
      // goTo(){
 
      //   if(this.HK4KL.id == 1){
      //     this.$router.push({name: "JRB"});
      //   }else{
      //     this.$router.push({name: "ringkasanMaklumatIR"});
      //   }
      //   //this.$router.push({name: "hk2", params: { data: this.data }});
      // },
    },
    watch:{
      HK4S38(val){
        var valueS38 = val.id;
        if(valueS38 == 1){
          //setkan value s42,s43 jadi 0
          this.HK4a1 = 0;
          this.HK4a2 = 0;
          this.HK4a3 = 0;
          this.soalanAkaunPenyataYa = true;
          this.soalanAkaunPenyataTidak = false;
        }
        if(valueS38 == 2){
          //setkan soalan s39,s40,s41 jadi 0
          this.HK4S39 = 0;
          this.HK4b1 = 0;
          this.HK4b2 = 0;
          this.soalanAkaunPenyataYa = false;
          this.soalanAkaunPenyataTidak = true;
        }

      },
      HK4S39(){
        if(this.HK4S39 >=6){
          this.showS40 = true;
          this.showS41 = false;
        }else{
          this.showS40 = false;
          this.showS41 = true;
        }
      },
      // HK421bi(){
      //   this.HK4INCS21bi = Number(this.HK421bi)*Number(this.HK4INCS21b)/100;
      // },
      // // HK421bii(){
      // //   this.HK4INCS21bii = Number(this.HK421bii)*Number(this.HK4INCS21b)/100;
      // // },
      // HK421biii(){
      //   this.HK4INCS21biii = Number(this.HK421biii)*Number(this.HK4INCS21b)/100;
      // },
      HK4a3(){
        this.HK4a4 = Number(this.HK4a2)-Number(this.HK4a3);
      },
      HK4b1(){
        this.HK4C1 = this.HK4b1;
      },
      HK4b2(){
        this.HK4C1 = this.HK4b2;
      },
      HK4a4(){
        this.HK4C1 = Number(this.HK4a4) * Number(this.HK4a1);
      },
      HK4C2(){
        this.HK4C3 = Number(this.HK4C1) * Number(this.HK4C2)/100;
      },
      HK4C4(){
        this.HK4INCS21b = Number(this.HK4C3) + Number(this.HK4C4);
      },
      HK421bii(){
        this.HK4INCS21bii = Number(this.HK421bii)*Number(this.HK4INCS21b)/100;

        this.HK421biii = Number(this.HK421bi) + Number(this.HK421bii);
        this.HK421biii = 100 - Number(this.HK421biii);
        // this.HK4INCS21b = Number(this.HK421bi) + Number(this.HK421bii) + Number(this.HK421biii)
      },
      HK4M(val){
    
        if(isNaN(val)){
            this.disabledInput = true;
          }else{
            this.disabledInput = false;
        }
      }
    },
    computed:{
     
      computedHK4a4: function(){
        var total = 0;
        total = Number(this.HK4a2) - Number(this.HK4a3);
        return total;
      },
      tambahlookupbulan() {
      return lookup.getBulan();
      },
      totalHK4INCS21b:  function(){
          var total = 0;
            ///calculate semua value HK4INCS21b yang telah di insert
            if(this.dataHK4.length >= 1){
              for(var i = 0; i < this.dataHK4.length ; i++){
                total = total + Number(this.dataHK4[i].HK4INCS21b)
              }
            }
          
          ///tambahkan total yang telah diinsert dengan current HK4INCS21b yang bakal diinsert
          //total = total + Number(this.HK4INCS21b) - Number(this.selectedData.HK4INCS21b);
          if(this.selectedData.HK4INCS21b){
              total = total + Number(this.HK4INCS21b) - Number(this.selectedData.HK4INCS21b);
          }else{
              total = total + Number(this.HK4INCS21b) ;
          }
          
          return total;
      }, 
      totalHK4INCS21B_i:  function(){

          var total = 0;
          if(this.dataHK4.length >= 1){
            ///calculate semua value HK3INCS21A_i yang telah di insert
            for(var i = 0; i < this.dataHK4.length ; i++){
              total = total + Number(this.dataHK4[i].HK4INCS21b_i)
            }
          }

          ///tambahkan total yang telah diinsert dengan current HK3INCS21A_i yang bakal diinsert
          //total = total + Number(this.HK4INCS21bi) - Number(this.selectedData.HK4INCS21bi);
          if(this.selectedData.HK4INCS21bi){
              total = total + Number(this.HK4INCS21bi) - Number(this.selectedData.HK4INCS21bi);
          }else{
              total = total + Number(this.HK4INCS21bi) ;
          }
          return total;

      }, 
      totalHK4INCS21B_ii:  function(){

          var total = 0;
          if(this.dataHK4.length >= 1){
            ///calculate semua value HK4INCS21B_ii yang telah di insert
            for(var i = 0; i < this.dataHK4.length ; i++){
              total = total + Number(this.dataHK4[i].HK4INCS21b_ii)
            }
          }

          ///tambahkan total yang telah diinsert dengan current HK4INCS21B_ii yang bakal diinsert
          //total = total + Number(this.HK4INCS21bii) - Number(this.selectedData.HK4INCS21bii);
          if(this.selectedData.HK4INCS21bii){
              total = total + Number(this.HK4INCS21bii) - Number(this.selectedData.HK4INCS21bii);
          }else{
              total = total + Number(this.HK4INCS21bii) ;
          }
          return total

      }, 
      totalHK4INCS21B_iii:  function(){

         var total = 0;
         if(this.dataHK4.length >= 1){
          ///calculate semua value HK4INCS21B_iii yang telah di insert
          for(var i = 0; i < this.dataHK4.length ; i++){
            total = total + Number(this.dataHK4[i].HK4INCS21b_iii)
          }
         }

          ///tambahkan total yang telah diinsert dengan current HK3INCS21A_iii yang bakal diinsert
          //total = total + Number(this.HK4INCS21biii) - Number(this.selectedData.HK4INCS21biii);
          if(this.selectedData.HK4INCS21biii){
              total = total + Number(this.HK4INCS21biii) - Number(this.selectedData.HK4INCS21biii);
          }else{
              total = total + Number(this.HK4INCS21biii) ;
          }
          return total

      },
      schemeRule() {
      return schemeRule;
    },

    }
}
</script>